var exports = {
  "kL": "EmojiTooltipContent.module__container___cHYwYW",
  "Zg": "EmojiTooltipContent.module__emoji___cHYwYW",
  "FS": "EmojiTooltipContent.module__textContainer___cHYwYW",
  "Lq": "EmojiTooltipContent.module__loading___cHYwYW",
  "W$": "EmojiTooltipContent.module__subtext___cHYwYW",
  "vW": "EmojiTooltipContent.module__inner___cHYwYW",
};

module.exports = exports;
